

















































































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import { Estoque, Page, SituacaoDoProdutoNaLoja } from '@/models'
import { CancelToken } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Pageable } from '@/models/Pageable'
import { FindEstoqueUseCase, FindProdutoUseCase } from '@/usecases'
import { formatarMoeda } from '@/shareds/formatadores'
import copy from 'copy-to-clipboard'
import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import { DataOptions } from 'vuetify'


@Component({
	components: {
		SeletorDeMarca,
		DataTableDeCrud,
		SeletorDeLojasDoUsuario,
	},
})
export default class PainelDaSituacaoDosProdutos extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrud
	@Ref() readonly campoDeBusca!: HTMLInputElement

	produtos: SituacaoDoProdutoNaLoja[] = []
	estoques: Estoque[] = []
	pagina: Page<SituacaoDoProdutoNaLoja> | null = null
	novoPaginavel: Pageable | null = null
	cancelToken!: CancelToken
	totalDeElementos = -1

	findEstoqueUseCase = new FindEstoqueUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	formatarMoeda = formatarMoeda

	carregando = false
	marcasId: string[] = []
	lojaId: string | null = ''
	errorMessage = ''
	divergenciasFiscais = true
	divergenciasNoEstoque = true
	divergenciasNoPreco = true
	mostraMensagemEans = false
	busca: string | null = ''
	filtroPorEans: string[] = []
	produtosInexistentes: string[] = []
	


	copyToClipboard = copy
	AlertModule = AlertModule
	
	paginavel: DataOptions = {
		page: - 1,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}


	headers = [
		{ text: 'Produto', value: 'nomeDoProduto', sortable: false },
		{ text: 'SKUs', value: 'sku', sortable: false },
		{ text: 'Eans', value: 'ean', sortable: false },
		{ text: 'Marca', value: 'nomeDaMarca', sortable: false },
		{ text: 'Fiscal', value: 'feedbackFiscal', sortable: false, align: 'center' },
		{ text: 'Estoque', value: 'feedbackDoEstoque', sortable: false, align: 'center' },
		{ text: 'Preço', value: 'feedbackDosPrecos', sortable: false, align: 'center' },
	]

	async buscarProdutos(cancelToken: CancelToken) {
		if (!this.lojaId) return []
		this.carregando = true

		try {
			if(this.filtroPorEans.length > 0) {
				const diminuiPagina = this.paginavel.page - 1
				const params = {
					page: 0,
					busca: this.busca || undefined,
					size: this.paginavel.itemsPerPage,
				}
		
				let inicio = 0
				let fim = this.paginavel.itemsPerPage

				if((diminuiPagina || 0) > 0) {
					inicio = (diminuiPagina || 1) * (this.paginavel.itemsPerPage || 10) 
					fim = inicio + (this.paginavel.itemsPerPage || 10)
				}

				const list = this.filtroPorEans.slice(inicio, fim)
				const parametros = {
					marcas: this.marcasId,
					divergenciasFiscais: this.divergenciasFiscais,
					divergenciasNoEstoque: this.divergenciasNoEstoque,
					divergenciasNoPreco: this.divergenciasNoPreco,
					buscaPorSkuOuEan: this.busca || "",
					eans: this.filtroPorEans,
				}

				const pagina = await this.findProdutoUseCase.buscaSituacaoDosProdutos(this.lojaId, {
					...parametros,
					eans: list,
					...params,
				}, {
					cancelToken,
				})

				this.produtos = pagina.content
				this.totalDeElementos = this.filtroPorEans.length
				this.produtosInexistentes = list.filter(ean => !pagina.content.some(p => p.ean === ean))

				if(this.produtosInexistentes.length > 0) {

					for(const ean of this.produtosInexistentes) {
						const produtoFalso: SituacaoDoProdutoNaLoja = {
							produtoId: '',
							lojaId: '',
							nomeDoProduto: '',
							nomeDaLoja: '',
							marca: null,
							sku: '',
							ean: ean,
							feedbackFiscal: 'false',
							feedbackDoEstoque: 'false',
							feedbackDosPrecos: 'false',
						}
						
						if(this.marcasId.length < 1) {
							this.produtos.push(produtoFalso)
						}
					}
				}
				return this.produtos
			} else {
				
				const parametrosPadrao = {
					marcas: this.marcasId,
					divergenciasFiscais: this.divergenciasFiscais,
					divergenciasNoEstoque: this.divergenciasNoEstoque, 
					divergenciasNoPreco: this.divergenciasNoPreco,
					buscaPorSkuOuEan: this.busca,
					eans: this.filtroPorEans,
				}

				const pagina = await this.findProdutoUseCase.buscaSituacaoDosProdutos(this.lojaId, {
					...parametrosPadrao,
					...this.novoPaginavel,
				}, {
					cancelToken,
				})
				this.produtos = pagina.content
	
				return pagina
			}
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}


	@Watch('paginavel', { deep: true })
	onChangePaginavel() {
		this.buscarProdutos(this.cancelToken)
	}

	get produtosFormatados() {
		return this.produtos.map(informacoesDoProduto => ({
			...informacoesDoProduto,
			nomeDaMarca: informacoesDoProduto.marca?.nome || '',
		}))
	}

	aplicarFiltros() {
		if (!this.lojaId) AlertModule.setError('Selecione uma loja para prosseguir')
		this.buscarProdutos(this.cancelToken)
	}
}
